<script setup lang="ts">
const route = useRoute();
useHead({
  title: "Department of Approvals",
  meta: [
    {
      hid: "description",
      name: "description",
      content:
        "The Department of Approvals, LLC (DofA) enables property owners, contractors, and architects to begin construction immediately.  Our team specializes in creating detailed mechanical, plumbing, fire alarm, and sprinkler plans that match the increasingly complex building requirements from the NYC Department of Buildings (DOB).",
    },
  ],
});

 import { useCollection } from "vuefire";
import { ref, onMounted } from 'vue';
import { doc, getDoc } from 'firebase/firestore';

const showAnnouncement = ref(true);
const announcement = ref(null);

    onMounted(async () => {
      try {
      const db = useFirestore();
        const docRef = doc(db, "announcement", "announcement");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          announcement.value = docSnap.data();
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    });
    
const showNavBar = ref(true);

watchEffect(() => {
  if (route.path === '/') {
    showNavBar.value = true;
  } else {
    setTimeout(() => {
      showNavBar.value = false;
    }, 400); // Adjust the time as needed
  }
});
</script>

<template>
  <div class="app flex flex-col w-screen h-screen">
       <transition name="announcement">
    <div v-show="announcement?.show && showAnnouncement" class="absolute top-0 w-screen z-50 bg-primary px-6 md:px-10 flex items-baseline text-sm">{{announcement && announcement.message}}
      <button class="ml-auto mt-0 p-0.5 hover:underline" @click="showAnnouncement = false">hide</button>
    </div>
    </transition>
    <div
      class="app__slot h-full overflow-y-hidden page-padding-y"
      style="min-height: calc(100vh - 4rem)"
    >
      <slot></slot>
    </div>
  <navbar v-show="showNavBar"
    :class="route.path === '/' ? 'absolute bottom-0 flex-shrink-0 z-50 transition-opacity duration-300' : 'flex-shrink-0 absolute bottom-0 z-50 translate-y-16 duration-300'">
  </navbar>
  </div>
</template>

<style>
.page-padding-x {
  @apply md:px-8;
}
.page-padding-y {
  @apply py-4 pb-16;
}
.app {
  @apply antialiased duration-300 bg-black text-white w-screen;
}

.page-left-enter-active,
.page-right-enter-active,
.page-left-leave-active,
.page-right-leave-active {
  overflow: visible;
  transition: all 200ms cubic-bezier(0.23, 0.91, 0.57, 0.93);
  transform-origin: left center;
  height: 50vh;
  overflow: visible;
  transform-style: preserve-3d;
  position: fixed;
  backface-visibility: hidden;
  top: 1rem;
  left: -1.5rem;
  right: 0;
  padding: 0 1.5rem;
  transition:
    transform 250ms ease-out,
    opacity 100ms 200ms ease;
  width: 100vw;
  @media (min-width: 768px) {
    left: -4rem;
    padding: 0 4rem;
  }
}

.page-left-enter-from,
.page-right-leave-to {
  transform: perspective(70rem) rotateY(90deg) translateX(5rem);
  opacity: 0;
  pointer-events: none;
}

.page-left-leave-to,
.page-right-enter-from {
  transform: perspective(70rem) rotateY(-90deg) translateX(-5rem);
  opacity: 0;
  pointer-events: none;
}

.page-right-enter-to {
  transform: perspective(70rem) rotateY(0deg) translateX(0rem);
  opacity: 1;
  transition-duration: 0.4s;
}
.page-left-enter-to {
  transform: perspective(70rem) rotateY(0deg) translateX(1.5rem)
    translateY(1rem);
  opacity: 1;
  transition-duration: 0.4s;
}


.announcement-move, /* apply transition to moving elements */
.announcement-enter-active,
.announcement-leave-active {
  transition:
    opacity 0.3s linear;
}

.announcement-enter-from,
.announcement-leave-to {
  opacity: 0;
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.announcement-leave-active {
  position: absolute;
}
</style>
